// Components==============
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useRef } from 'react';
import { InputColor, TranslateType } from 'typings';
import { FormContext } from 'utilities/FormContext';
import './Form.module.scss';
// =========================

type Props = {
  name: string;
  label?: TranslateType;
  required?: boolean;
  autoComplete?: string;
  color?: InputColor;
  placeholder?: TranslateType;
  ext_formValue?: string;
  ext_onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleDelete?: () => void;
  focusEffect?: boolean;
  labelLocation?: 'center' | 'left';
};

export default function Input({
  name,
  label,
  required = true,
  autoComplete,
  color = 'grey',
  placeholder = '',
  ext_formValue,
  ext_onChange,
  onKeyDown,
  handleDelete,
  focusEffect,
  labelLocation = 'center',
}: Props) {
  const { onChange, formValues, errors } = useContext(FormContext);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focusEffect) ref.current?.focus();
  }, [focusEffect]);

  return (
    <div styleName={`wrapper ${labelLocation}`}>
      {label && <label htmlFor={name}>{label}</label>}
      <input
        type={
          name === 'email'
            ? 'email'
            : name.includes('password')
            ? 'password'
            : 'text'
        }
        name={name}
        onChange={onChange || ext_onChange}
        value={formValues?.[name] || ext_formValue || ''}
        required={required}
        autoComplete={autoComplete}
        styleName={`input ${color}`}
        placeholder={placeholder as string}
        onKeyDown={onKeyDown}
        style={{ paddingRight: handleDelete ? '2rem' : 0 }}
        ref={ref}
      />
      {!!handleDelete && (
        <div styleName="delete" onClick={handleDelete}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
      {errors?.[name][0] ? <p styleName="error">{errors?.[name][0]}</p> : null}
    </div>
  );
}
